import React, { Suspense } from 'react';
import { PopupLearnMoreLongTermPlans } from 'src/components/popup-learn-more-long-term-plans';
import { PopupLearnMorePayInFull } from 'src/components/popup-learn-more-pay-in-full';
import { PopupLearnMoreWithSchedule } from 'src/components/popup-learn-more-with-schedule';
import { PopupNonStandartLearnMore } from 'src/components/popup-non-standart-learn-more';
import { ACTIONS } from 'src/constants/common';
import {
  type LearnMoreType,
  useAppContext,
} from 'src/context/store/app-provider';

export const LearnMore = () => {
  const { dispatch, learnMoreVisibility } = useAppContext();

  const closeDialog = (type: LearnMoreType) => {
    dispatch({
      type: ACTIONS.SHOW_LEARN_MORE,
      payload: { [type]: false },
    });
  };

  return (
    <Suspense fallback={null}>
      <PopupNonStandartLearnMore
        isShow={learnMoreVisibility.default}
        onClose={() => closeDialog('default')}
      />

      <PopupLearnMoreLongTermPlans
        isShow={learnMoreVisibility.ltf}
        onClose={() => closeDialog('ltf')}
      />

      <PopupLearnMoreWithSchedule
        isShow={learnMoreVisibility.pix}
        onClose={() => closeDialog('pix')}
      />

      <PopupLearnMorePayInFull
        isShow={learnMoreVisibility.pif}
        onClose={() => closeDialog('pif')}
      />
    </Suspense>
  );
};
